export default __webpack_public_path__ + "static/media/project-management-icon.dd2202ae.svg";